mutation TravelAuthorizationExportFilter(
  $input: TravelAuthorizationExportFilterInput!
) {
  travelAuthorizationExportFilter(input: $input) {
    exportResult {
      exportCycles
    }
  }
}
